import { useSyncExternalStore } from 'react'

export interface SelectedCompany {
  companyId: string
  companyName: string
  usertype: string
}

type SelectedCompanyListener = () => void

const selectedCompanyListeners = new Set<SelectedCompanyListener>()

function readSelectedCompanyFromStorage(): SelectedCompany {
  return {
    companyId: localStorage.getItem('CompanyId') ?? '',
    companyName: localStorage.getItem('CompanyName') ?? '',
    usertype: localStorage.getItem('UserType') ?? '',
  }
}

let selectedCompanySnapshot = readSelectedCompanyFromStorage()

function notifySelectedCompanyChanged(): void {
  selectedCompanyListeners.forEach((listener) => listener())
}

export function getSelectedCompany(): SelectedCompany {
  return selectedCompanySnapshot
}

export function setSelectedCompany(companyId: string, companyName: string, usertype: string): void {
  selectedCompanySnapshot = { companyId, companyName, usertype }
  localStorage.setItem('CompanyId', companyId)
  localStorage.setItem('CompanyName', companyName)
  notifySelectedCompanyChanged()
}

export function syncSelectedCompanyFromStorage(): void {
  selectedCompanySnapshot = readSelectedCompanyFromStorage()
  notifySelectedCompanyChanged()
}

export function clearSelectedCompany(): void {
  const usertype = localStorage.getItem('UserType') ?? ''
  selectedCompanySnapshot = { companyId: '', companyName: '', usertype }
  localStorage.removeItem('CompanyId')
  localStorage.removeItem('CompanyName')
  notifySelectedCompanyChanged()
}

export function subscribeSelectedCompany(listener: SelectedCompanyListener): () => void {
  selectedCompanyListeners.add(listener)
  return () => selectedCompanyListeners.delete(listener)
}

export function useSelectedCompany(): SelectedCompany {
  return useSyncExternalStore(
    subscribeSelectedCompany,
    getSelectedCompany,
    () => ({ companyId: '', companyName: '', usertype: '' }),
  )
}

